import { applySnapshot, flow, types } from "mobx-state-tree";
import moment from "moment";
import { type } from "os";
import { ErrorModel } from "../../components/common/error";
import { MessageModel } from "../../components/common/message";
import i18n from "../../i18n";
import { IInput } from "../../utils/common-interface";
import { convertToCurrencyNumber } from "../../utils/convert-to-currency-number";
import customtypes from "../../utils/mobx-types-helper";
import authStore from "../auth/AuthModel";
import { ActionModel, ILOVModel,LOVGroupModel } from "../org/OrganizeModel";
import { CurrencyModel, SelectListModel } from "../share";
import { ActivityModel, IActivityModel, ResultLOVModel,ResultLOVOrNullModel,AmountContractModel, IResultLOVModel } from "../share/ActivityModel";
import { SDGDetailModel,AmountSDGModel,yearPlanSDGModel } from "../share/SDGDetailModel";
import { LoanSourcesModel, LoanTypeModel, TotalLoanByYearModel } from "../share/LoanModel";
import projectAPI from "./ProjectService";
import SDGsAPI from "../../modules/sdgs/SDGsService";
import { dataSdgHeader,dataSdgSub } from "../../constants";
import systemHelperAPI from "../systemhelper/SystemHelperService";
var Wkt = require('wicket');

export const ProjTypeLoanByYearModel = types
    .model("ProjTypeLoanByYearModel", {
        projectTypeCode: customtypes.optional(types.string, ""),
        projectTypeName: customtypes.optional(types.string, ""),
        loanByYear: types.optional(types.array(TotalLoanByYearModel), []),
    })
    .views((self: any) => ({
        get filterOption() {
            return {
                label: self.projectTypeName,
                value: self.projectTypeCode,
            };
        },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IProjTypeLoanByYearModel = typeof ProjTypeLoanByYearModel.Type;

export const ProjectTypeLoanSummaryModel = types
    .model("ProjectTypeLoanSummaryModel", {
        projectType: customtypes.optional(types.string, ""),
        projectTypeSumAmount: customtypes.optional(types.number, 0),
        loanTypeSumAmount: types.optional(types.array(LoanTypeModel), []),
    })
    .views((self: any) => ({
        get projectTypeSumAmountAsMillion() {
            return self.projectTypeSumAmount / 1000000;
        },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IProjectTypeLoanSummaryModel = typeof ProjectTypeLoanSummaryModel.Type;

export const ExpenseSummaryModel = types
    .model("ExpenseSummaryModel", {
        grandTotal: customtypes.optional(types.number, 0),
        totalLoan: customtypes.optional(types.number, 0),
        localLoan: customtypes.optional(types.number, 0),
        foreignLoan: customtypes.optional(types.number, 0),
        otherLoan: customtypes.optional(types.number, 0),
    })
    .views((self: any) => ({
        get grandTotalAsMillionBaht() {
            return self.grandTotal / 1000000;
        },
        get totalLoanAsMillionBaht() {
            return self.totalLoan / 1000000;
        },
        get localLoanAsMillionBaht() {
            return self.localLoan / 1000000;
        },
        get foreignLoanAsMillionBaht() {
            return self.foreignLoan / 1000000;
        },
        get otherLoanAsMillionBaht() {
            return self.otherLoan / 1000000;
        },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IExpenseSummaryModel = typeof ExpenseSummaryModel.Type;

export const StatusCheckingModel = types
    .model("StatusCheckingModel", {
        id: types.maybeNull(types.number),
        code: customtypes.optional(types.string, ""),
        description: customtypes.optional(types.string, ""),
        pdmoCheck: customtypes.optional(types.boolean, false),
        resolutionCheck: customtypes.optional(types.boolean, false),
        percent: customtypes.optional(types.number, 0),
        amount: customtypes.optional(types.number,0),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IStatusCheckingModel = typeof StatusCheckingModel.Type;

export const MaterialsModel = types
    .model("MaterialsModel", {
        sourceType: customtypes.optional(types.string, ""),
        limitAmount: customtypes.optional(types.number, 0),
        currencyCode: customtypes.optional(types.string, ""),
        thbAmount: customtypes.optional(types.number, 0),
        ratio: customtypes.optional(types.number, 0),
    })
    .views((self: any) => ({
        get ratioWith2Decimal() {
            return self.ratio.toFixed(2);
        },
        get limitAmountAsMillion() {
            return self.limitAmount / 1000000;
        },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IMaterialsModel = typeof MaterialsModel.Type;

export const LocationModel = types
    .model("LocationModel", {
        id: types.maybeNull(types.number),
        no: types.maybeNull(types.number),
        location: customtypes.optional(types.string, ""),
        latitude: customtypes.optional(types.number, 0),
        longitude: customtypes.optional(types.number, 0),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type ILocationModel = typeof LocationModel.Type;

export const WktModel = types
    .model("WktModel", {
        lat: customtypes.optional(types.number, 0),
        lng: customtypes.optional(types.number, 0),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IWktModel= typeof WktModel.Type;

export const ProjectWktModel = types
    .model("ProjectWktModel", {
        id: types.maybeNull(types.number),
        no: types.maybeNull(types.number),
        extendData: customtypes.optional(types.string, ""),
        groupCode: customtypes.optional(types.string, ""),
    })
    .views((self: any) => ({
        get getTypeWkt() {
            try{
                var wkt = new Wkt.Wkt();
                wkt.read(self.extendData);
                return wkt.type;
            }catch{

            }
        },
        get getPositionMarker() {
            var wkt = new Wkt.Wkt();
            wkt.read(self.extendData);
            var i;
            const wktObj=wkt.components ;
            for(i = 0; i < wktObj.length; i++){
            wktObj[i].lat = wktObj[i]['y'];
            delete wktObj[i].y;
            wktObj[i].lng = wktObj[i]['x'];
                delete wktObj[i].x;
            }
            return wktObj.length>0 ?wktObj[0]:null ;
        },
        get getListPositionMutiMarker() {
            var wkt = new Wkt.Wkt();
            wkt.read(self.extendData);
            let listMuti=[];
            const wktObj=wkt.components ;
            for(var i = 0; i < wktObj.length; i++){
                for(var j = 0; j < wktObj[i].length; j++){
                    wktObj[i][j] .lat = wktObj[i][j]['y'];
                    delete wktObj[i][j].y;
                    wktObj[i][j].lng = wktObj[i][j]['x'];
                    delete wktObj[i][j].x;
                    listMuti.push(wktObj[i][j]);
                }

            }
            return listMuti;
        },
        get getLatLngLinestring() {
            var wkt = new Wkt.Wkt();
            wkt.read(self.extendData);
            var i;
            const wktObj=wkt.components;
            for(i = 0; i < wktObj.length; i++){
            wktObj[i].lat = wktObj[i]['y'];
            delete wktObj[i].y;
            wktObj[i].lng = wktObj[i]['x'];
                delete wktObj[i].x;
            }
            return wktObj;
        },
        get getLsitMultiLineString() {
            var wkt = new Wkt.Wkt();
            wkt.read(self.extendData);
            const wktObj=wkt.components ;
            for(var i = 0; i < wktObj.length; i++){
                for(var j = 0; j < wktObj[i].length; j++){
                    wktObj[i][j] .lat = wktObj[i][j]['y'];
                    delete wktObj[i][j].y;
                    wktObj[i][j].lng = wktObj[i][j]['x'];
                    delete wktObj[i][j].x;
                }

            }
            return wktObj;
        },
        get getLatLngPlygon() {
            var wkt = new Wkt.Wkt();
            wkt.read(self.extendData);
            var i;
            const wktObj=wkt.components.length>0 ?wkt.components[0] : null;
            for(i = 0; i < wktObj.length; i++){
            wktObj[i].lat = wktObj[i]['y'];
            delete wktObj[i].y;
            wktObj[i].lng = wktObj[i]['x'];
                delete wktObj[i].x;
            }
            return wktObj;
        },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IProjectWkt = typeof ProjectWktModel.Type;

export const ResolutionFileModel = types
    .model("ResolutionFileModel", {
        id: types.maybeNull(types.number),
        fileDetail: types.maybeNull(types.string),
        fileName: types.maybeNull(types.string),
        fileExtension: types.maybeNull(types.string),
        fileSize: types.maybeNull(types.number),
        fileData: types.maybeNull(types.string),
        clearFile: types.maybeNull(types.boolean),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IResolutionFileModel = typeof ResolutionFileModel.Type;

export const ResolutionModel = types
    .model("ResolutionModel", {
        id: types.maybeNull(types.number),
        no: types.maybeNull(types.number),
        detail: customtypes.optional(types.string, ""),
        date: customtypes.optional(types.string, ""),
        amount: customtypes.optional(types.number,0),
        file: types.maybeNull(ResolutionFileModel),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IResolutionModel = typeof ResolutionModel.Type;

export const ProjectSubMenuModel = types
    .model("ProjectSubMenuModel", {
        id: types.maybeNull(types.number),
        no: types.maybeNull(types.number),
        extendData: customtypes.optional(types.string, ""),
        groupCode: customtypes.optional(types.string, ""),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IProjectSubMenuModel = typeof ProjectSubMenuModel.Type;

export const BuggetAllocationsModel = types
    .model("BuggetAllocationsModel", {
        source: customtypes.optional(LoanSourcesModel, { currency: "THB", sourceType: "L" }),
        months: customtypes.optional(types.array(types.number), [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
    })
    .views((self: any) => ({
        get sumMonthloanAmount() {
            const sum = self.months.reduce((sum: number, item: number) =>
                sum + item, 0);
            return sum ? sum : 0;
        },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IBuggetAllocationsModel = typeof BuggetAllocationsModel.Type;

export const BuggetAllocationYearPlanModel = types
    .model("BuggetAllocationYearPlanModel", {
        year: customtypes.optional(types.union(types.number, types.string), ""),
        buggetAllocations: customtypes.optional(types.array(BuggetAllocationsModel), []),
    })
    .views((self: any) => ({
        // get ratioWith2Decimal() {
        //     return self.ratio.toFixed(2);
        // },
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        onAddbuggetAllocations: () => {
            self.buggetAllocations.push(BuggetAllocationsModel.create({}));
        },
        onAddbuggetAllocationsF: () => {
            const bugget = BuggetAllocationsModel.create({});
            bugget.source.setField({ fieldname: "currency", value: "USD" });
            bugget.source.setField({ fieldname: "sourceType", value: "F" });
            self.buggetAllocations.push(bugget);
        },
        onRemovebuggetAllocation: (index: number) => {
            self.buggetAllocations.splice(index, 1);
        },
    }));
export type IBuggetAllocationYearPlanModel = typeof BuggetAllocationYearPlanModel.Type;

export const projSDGModel = types
    .model("projSDGModel", {
      projSDGID: types.maybeNull(types.number),
      projCode:  customtypes.optional(types.string, ""),
      thbAmount: customtypes.optional(types.number, 0),
      percent: customtypes.optional(types.number, 0),
      amounts: types.optional(types.array(AmountSDGModel), [
      ]),
      sdgs:  types.maybeNull(types.array(SDGDetailModel)),
      createdAt:  customtypes.optional(types.string, ""),
      createdByUserId:  customtypes.optional(types.string, ""),
      updatedAt:  customtypes.optional(types.string, ""),
      updatedByUserId:  customtypes.optional(types.string, ""),
      error: customtypes.optional(ErrorModel, {}),
      loading: types.optional(types.boolean, false),
      alert: types.optional(MessageModel, {}),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        getGetProjectSDGByCode: flow(function * (isLoading : boolean) {
            try { 
              self.loading = isLoading;
              const result = yield SDGsAPI.GetProjectSDGByCode(self.projCode);
              self.setAllField(result.data);
              self.loading = false;
              self.error.tigger = false;
            } catch (e) {
                self.loading = false;
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        UpdateProjectSDG: flow(function* (isAlert:boolean) {
            try {
                if(isAlert){
                    self.loading = true
                }
                // console.log('self checked',self)
                const result = yield SDGsAPI.UpdateProjectSDG(
                    
                    { ...self },
                );
                self.loading = false
                if(isAlert){
                    self.alert.tigger = true;
                    self.alert.title = i18n.t("บันทึกข้อมูลแล้ว");
                    self.alert.message = i18n.t("บันทึกข้อมูลเรียบร้อยแล้ว");
                }
            } catch (e) {
                self.loading = false
                self.error.tigger = true;
                self.error.title = i18n.t("บันทึกข้อมูลไม่สำเร็จ");
                self.error.message = i18n.t("บันทึกข้อมูลไม่สำเร็จ โปรดลองใหม่อีกครั้ง");
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                //
            }
        }),
        setAllField: (data: any) => {
            Object.keys(data).forEach((key) => {
                try {
                    if (key == "iipmSyncErrors"){
                        var err = data[key];
                        if (err && err.length > 0){
                            self[key] = '<li>' + err.join('</li><li>') + '</li>';
                        }else{
                            self[key] = null;
                        }
                    }else{
                        self[key] = data[key];
                    }
                    
                    
                } catch (e) {
                    console.log("exception on mapping key:", key);
                }
            });
        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
    }));
export type IProjSDGModel = typeof projSDGModel.Type;


export const ProjectModel = types
    .model("ProjectModel", {
        projectID: customtypes.optional(types.number, 0),
        organizationID: customtypes.optional(types.number, 0),
        organization: customtypes.optional(SelectListModel, {}),
        projectCode: customtypes.optional(types.string, ""),
        projectType: types.optional(SelectListModel, {}),
        limitAmount: customtypes.optional(types.union(types.number, types.string), 0),
        startYear: customtypes.optional(types.number, 0),
        projectTHName: customtypes.optional(types.string, ""),
        projectENName: customtypes.optional(types.string, "-"),
        projectBranch: customtypes.optional(types.string, ""),
        capitalSource: customtypes.optional(types.string, ""),
        startDate: customtypes.optional(types.string, ""),
        endDate: customtypes.optional(types.string, ""),
        processTime: customtypes.optional(types.string, ""),
        projectBackground: customtypes.optional(types.string, ""),
        projectConsistency: customtypes.optional(types.string, ""),
        projectTarget: customtypes.optional(types.string, ""),
        projectObjective: customtypes.optional(types.string, "-"),
        projectScope: customtypes.optional(types.string, "-"),
        materials: customtypes.optional(types.array(MaterialsModel),
            [
                { sourceType: "L", currencyCode: "THB" },
                { sourceType: "F", currencyCode: "USD" },
            ],
        ),
        firr: customtypes.optional(types.number, 0),
        eirr: customtypes.optional(types.number, 0),
        isNewProject: customtypes.optional(types.boolean, false),
        projectStatuses: types.maybeNull(types.array(StatusCheckingModel)),
        // 
        mapDrawing: customtypes.optional(types.string, ""),
        directorName: types.maybeNull(types.string),
        directorPosition: types.maybeNull(types.string),
        directorMail: types.maybeNull(types.string),
        directorTel: types.maybeNull(types.string),
        province: types.maybeNull(ResultLOVModel),
        sector: types.maybeNull(ResultLOVModel),
        subSector: types.maybeNull(ResultLOVModel),
        status: types.maybeNull(ResultLOVModel),
        creditChannel: types.maybeNull(ResultLOVModel),
        isOnGoing: customtypes.optional(types.boolean, false),
        isGovBurden: customtypes.optional(types.boolean, false),
        hasEld: customtypes.optional(types.boolean, false),
        objectives: customtypes.optional(types.array(ProjectSubMenuModel), []),
        benefits: customtypes.optional(types.array(ProjectSubMenuModel), []),
        scopes: customtypes.optional(types.array(ProjectSubMenuModel), []),
        locations: customtypes.optional(types.array(LocationModel), []),
        productivities: customtypes.optional(types.array(ProjectSubMenuModel), []),
        iipmMaps: customtypes.optional(types.array(ProjectWktModel), []),
        resolutions: customtypes.optional(types.array(ResolutionModel), []),
        // 
        pdmoAgreement: customtypes.optional(types.number, 1),
        resolutionAgreement: customtypes.optional(types.number, 1),
        resolutionExpSum: customtypes.optional(ExpenseSummaryModel, {}),
        contractExpSum: customtypes.optional(ExpenseSummaryModel, {}),
        activities: types.maybeNull(types.array(ActivityModel)),
        lastUpdate: customtypes.optional(ActionModel, {}),
        currencyData: types.maybeNull(CurrencyModel),
        buggetAllocationPlans: customtypes.optional(types.array(BuggetAllocationYearPlanModel), []),
        projectSDG: customtypes.optional(projSDGModel,{}),
        error: customtypes.optional(ErrorModel, {}),
        loading: types.optional(types.boolean, false),
        alert: types.optional(MessageModel, {}),
        iipmSyncErrors: types.maybeNull(types.string),
        notFoundProject: types.optional(types.boolean, false),
        sdgAmount: customtypes.optional(types.union(types.number, types.string), 0), 
        projectRenameRemark: customtypes.optional(types.string, ""), 
        iipmApprovedStatus: types.maybeNull(types.boolean),
        selectedProjectID: types.maybeNull(types.number),
    })
    .views((self: any) => ({
        get localMaterial(): IMaterialsModel | undefined {
            return self.materials.find((matt: IMaterialsModel, index: number) =>
                matt.sourceType === "L",
            );
        },
        get importMaterials(): IMaterialsModel[] {
            return self.materials.filter((matt: IMaterialsModel, index: number) =>
                matt.sourceType === "F",
            );
        },
        get projectCodeView() {
            return self.projectCode || "-";
        },
        get projectTHNameView() {
            return self.projectTHName || "-";
        },
        get projectENNameView() {
            return self.projectENName || "-";
        },
        get projectBranchView() {
            return self.projectBranch || "-";
        },
        get capitalSourceView() {
            return self.capitalSource || "-";
        },
        get processTimeView() {
            return self.processTime || "-";
        },
        get projectBackgroundView() {
            return self.projectBackground || "-";
        },
        get projectConsistencyView() {
            return self.projectConsistency || "-";
        },
        get projectTargetView() {
            return self.projectTarget || "-";
        },
        get projectObjectiveView() {
            return self.projectObjective || "-";
        },
        get projectScopeView() {
            return self.projectScope || "-";
        },
        get activitiesProceedBudgetTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.budget, 0)
                :
                0;
        },
        get activitiesProceedRevernueTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.revernue, 0)
                :
                0;
        },
        get activitiesProceedDisburseLoanTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.disburseLoan, 0)
                :
                0;
        },
        get activitiesProceedOtherTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.other, 0)
                :
                0;
        },
        get activitiesProceedTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.total, 0)
                :
                0;
        },
        get limitAmountAsMillionBaht() {
            return self.limitAmount / 1000000;
        },
        get sdgAmountAsMillionBaht() {
            return self.sdgAmount / 1000000;
        },
        get dataMapDrawing() {
            return self.mapDrawing?JSON.parse(self.mapDrawing):null;
        },
    }))
    .actions((self: any) => ({
        getProjectDetails: flow(function* () {
            try {
                self.loading = true;
                const result = yield projectAPI.getProjectDetails(self.projectID);
                self.setAllField(result.data);
                // console.log('result.data',result.data)
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        getProjectDetailsByCode: flow(function* () {
            try {
                self.loading = true;
                const result = yield projectAPI.getProjectDetailsByCode(self.projCode);
                self.setAllField(result.data);
                // console.log('result.data',result.data)
            } catch (e) {
                self.notFoundProject=true;
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        getProjectDetailsByCodeIframe: flow(function* () {
            try {
                self.loading = true;
                const result = yield SDGsAPI.getByCodeByIframe(self.projCode);
                self.setAllField(result.data);
                // console.log('result.data',result.data)
            } catch (e) {
                self.notFoundProject=true;
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        getProjStatusList: flow(function* () {
            try {
                const result = yield projectAPI.getProjStatusList();
                self.projectStatuses = result.data;
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                //
            }
        }),
        createProject: flow(function* () {
            try {
                // set ค่า default ที่ไม่มีให้กรอกใน ​Form
                self.organizationID = authStore.userProfile.organizationID;
                self.iipmSyncErrors = "";
                self.sector=self.subSector?self.subSector:self.sector;
                // tslint:disable-next-line:max-line-length
               if (["COMP", "COMPY", "LIQ", "COVID", "COVID21", "OTHER", "SEC22", "ONLEND", "RELIEF"].includes(self.projectType.code)) { // project กู้เพื่อชดเชยขาดดุล กับ กู้เพื่อชดเชย ขาดดุลเลื่อมปี
               //if(["xxx"].includes(self.projectType.code)){
               self.loading = true;
                    const result = yield projectAPI.createMinimumProject({
                        projectID: self.projectID,
                        organizationID: self.organizationID,
                        projectCode: self.projectCode,
                        projectType: self.projectType,
                        projectTHName: self.projectTHName,
                        projectENName: self.projectENName,
                        projectRemark: self.projectObjective,
                        startYear: self.startYear,
                        limitAmount: self.limitAmount,
                        isNewProject: true,
                    });
                    self.loading = false;
                    self.alert.tigger = true;
                    self.alert.title = i18n.t("ProjectModel.finishingSubmit");
                    self.alert.message = i18n.t("ProjectModel.createdProjectInfo");
                    return result; // Reture projectId ที่สร้างใหม่ออกไป ให้ M127projectModal
                }
                else {
                    // self.startYear = +(moment(self.startDate).add(543, "years").format("YYYY"));
                    // ส่ง currencyData ไปแล้วAPI ไม่รับ ต้องเอาออก
                    if (["DEV"].includes(self.projectType.code)){
                        self.iipmApprovedStatus = false ; // ถ้าเป็นโครงการพัฒนา จะต้องอนุมัติ IIPM ก่อน
                    }
                    const { currencyData, ...rest } = self;
                    self.loading = true;
                    const result = yield projectAPI.createProject(rest);
                    self.loading = false;
                    self.alert.tigger = true;
                    self.alert.title = i18n.t("ProjectModel.finishingSubmit");
                    self.alert.message = i18n.t("ProjectModel.createdProjectInfo");
                    return result; // Reture projectId ที่สร้างใหม่ออกไป ให้ M127projectModal
                }
            } catch (e) {
                self.error.tigger = true;
                self.error.title = i18n.t("ProjectModel.failedSubmit");
                self.error.message = i18n.t("ProjectModel.pleaseTryAgain");
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                self.loading = false;
                throw e;
            } finally {
                //
            }
        }),
        updateProject: flow(function* (isAutoSave = false) {
            try {
                // แสดง loading เฉพาะเมื่อเป็นการบันทึกแบบ manual
                if (!isAutoSave) {
                self.loading = true;
                }
                
                // remove file model when empty
                self.resolutions.forEach((element: IResolutionModel) => {
                if (element.file && !element.file.fileName) {
                    element.file = null;
                }
                });
                
                self.iipmSyncErrors = "";
                self.sector = self.subSector ? self.subSector : self.sector;
                self.projectScope = self.projectScope && self.projectScope != "" ? self.projectScope : "-";
                
                if (self.activities && self.activities.length > 0) {
                self.activities.forEach((activity: IActivityModel) => {
                    const contractAmountsCopy = [...activity.contractAmounts]; // Create a shallow copy
                    
                    contractAmountsCopy.forEach((element: AmountContractModel) => {
                    if (element && element.sourceLoan) {
                        if (element.sourceLoan.id === undefined || element.sourceLoan.id === 0) {
                        // Find the index of the element to remove in the original array
                        const indexToRemove = activity.contractAmounts.indexOf(element);
                        if (indexToRemove !== -1) {
                            activity.contractAmounts.splice(indexToRemove, 1); // Remove from the original array
                        }
                        }
                    }
                    });
                });
                }
                
                if (["COMP", "COMPY", "LIQ", "COVID", "COVID21", "OTHER", "SEC22", "ONLEND", "RELIEF"].includes(self.projectType.code)) { // project กู้เพื่อชดเชยขาดดุล กับ กู้เพื่อชดเชย ขาดดุลเลื่อมปี
                //if(["xxx"].includes(self.projectType.code)){
                const result = yield projectAPI.updateMinimumProject(
                    self.projectID,
                    {
                    projectID: self.projectID,
                    organizationID: self.organizationID,
                    projectCode: self.projectCode,
                    projectType: self.projectType,
                    projectTHName: self.projectTHName,
                    projectENName: self.projectENName,
                    projectRemark: self.projectObjective,
                    startYear: self.startYear,
                    limitAmount: self.limitAmount,
                    isNewProject: self.isNewProject,
                    },
                );
                } else {
                const result = yield projectAPI.updateProject(
                    self.projectID,
                    { ...self },
                );
                }
                
                // ปิด loading และแสดง alert เฉพาะเมื่อเป็นการบันทึกแบบ manual
                if (!isAutoSave) {
                self.loading = false;
                self.alert.tigger = true;
                self.alert.title = i18n.t("ProjectModel.finishingSubmit");
                self.alert.message = i18n.t("ProjectModel.modifiedProjectInfo");
                }
                
                return true; // คืนค่า true เพื่อบอกว่าบันทึกสำเร็จ
            } catch (e) {
                console.log('error updateProject', e);
                
                // ปิด loading เสมอเมื่อเกิดข้อผิดพลาด
                self.loading = false;
                
                // แสดง error เฉพาะเมื่อเป็นการบันทึกแบบ manual
                if (!isAutoSave) {
                self.error.tigger = true;
                self.error.title = i18n.t("ProjectModel.failedSubmit");
                self.error.message = i18n.t("ProjectModel.pleaseTryAgain");
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                }
                
                throw e;
            } finally {
                if (!isAutoSave) {
                self.loading = false;
                }
            }
        }),
        updateProjectByIframe: flow(function* (accessToken?: string | null, isAutoSave = false) {
            try {
                // แสดง loading เฉพาะเมื่อเป็นการบันทึกแบบ manual
                if (!isAutoSave) {
                self.loading = true;
                }
                // remove file model when empty
                self.resolutions.forEach((element: IResolutionModel) => {
                if (element.file && !element.file.fileName) {
                    element.file = null;
                }
                });
                
                self.iipmSyncErrors = "";
                self.sector = self.subSector ? self.subSector : self.sector;
                self.projectScope = self.projectScope && self.projectScope != "" ? self.projectScope : "-";
                self.projectConsistency = self.projectConsistency && self.projectConsistency != "" ? self.projectConsistency : "-";
                 
                if (self.activities && self.activities.length > 0) {
                self.activities.forEach((activity: IActivityModel) => {
                    const contractAmountsCopy = [...activity.contractAmounts]; // Create a shallow copy
                    
                    contractAmountsCopy.forEach((element: AmountContractModel) => {
                    if (element && element.sourceLoan) {
                        if (element.sourceLoan.id === undefined || element.sourceLoan.id === 0) {
                        // Find the index of the element to remove in the original array
                        const indexToRemove = activity.contractAmounts.indexOf(element);
                        if (indexToRemove !== -1) {
                            activity.contractAmounts.splice(indexToRemove, 1); // Remove from the original array
                        }
                        }
                    }
                    });
                });
                }
                
                if (["COMP", "COMPY", "LIQ", "COVID", "COVID21", "OTHER", "SEC22", "ONLEND", "RELIEF"].includes(self.projectType.code)) { // project กู้เพื่อชดเชยขาดดุล กับ กู้เพื่อชดเชย ขาดดุลเลื่อมปี
                //if(["xxx"].includes(self.projectType.code)){
                const result = yield SDGsAPI.updateMinimumProjectByIframe(
                    self.projectID,
                    {
                    projectID: self.projectID,
                    organizationID: self.organizationID,
                    projectCode: self.projectCode,
                    projectType: self.projectType,
                    projectTHName: self.projectTHName,
                    projectENName: self.projectENName,
                    projectRemark: self.projectObjective,
                    startYear: self.startYear,
                    limitAmount: self.limitAmount,
                    isNewProject: self.isNewProject,
                    },
                    accessToken
                );
                } else {
                const result = yield SDGsAPI.updateProjectByIframe(
                    self.projectID,
                    { ...self },
                    accessToken
                );
                }
                
                // ปิด loading และแสดง alert เฉพาะเมื่อเป็นการบันทึกแบบ manual
                if (!isAutoSave) {
                self.loading = false;
                self.alert.tigger = true;
                self.alert.title = i18n.t("ProjectModel.finishingSubmit");
                self.alert.message = i18n.t("ProjectModel.modifiedProjectInfo");
                }
                
                return true; // คืนค่า true เพื่อบอกว่าบันทึกสำเร็จ
            } catch (e) {
                console.log('error updateProject', e);
                
                // ปิด loading เสมอเมื่อเกิดข้อผิดพลาด
                self.loading = false;
                
                // แสดง error เฉพาะเมื่อเป็นการบันทึกแบบ manual
                if (!isAutoSave) {
                self.error.tigger = true;
                self.error.title = i18n.t("ProjectModel.failedSubmit");
                self.error.message = i18n.t("ProjectModel.pleaseTryAgain");
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                }
                
                throw e;
            } finally {
                if (!isAutoSave) {
                self.loading = false;
                }
            }
        }),
        setAllField: (data: any) => {
            Object.keys(data).forEach((key) => {
                try {
                    if (key == "iipmSyncErrors"){
                        var err = data[key];
                        if (err && err.length > 0){
                            self[key] = '<li>' + err.join('</li><li>') + '</li>';
                        }else{
                            self[key] = null;
                        }
                    }else{
                        self[key] = data[key];
                    }
                    
                    
                } catch (e) {
                    console.log("exception on mapping key:", key);
                }
            });
        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        setProcessTime: () => {
            const startDate = moment(self.startDate);
            const endDate = moment(self.endDate);
            const diffDays = convertToCurrencyNumber(endDate.diff(startDate, "days") + 1, 0) || "";
            const diffYears = endDate.diff(startDate, "years") || "";
            const diffYearsText = diffYears ? `${diffYears} ปี ` : "";
            const diffDaysText = diffDays ? `(${diffDays} วัน)` : "";
            self.processTime = (diffYearsText + diffDaysText) || "";
        },
        setProjectType: (code: string | null, description: string) => {
            self.projectType.setField(
                0, code, description,
            );
        },
        onAddIipmMaps: (wktText: string) => {
            self.iipmMaps.push(ProjectWktModel.create({
                no: self.iipmMaps.length + 1,
                extendData : wktText,
                groupCode: "IIPMMAP"
            }));
        },
        onRemoveIipmMaps: () => {
            applySnapshot(self.iipmMaps, []);
        },
        onRemoveIipmMapsItem: (index: number) => {
            self.iipmMaps.splice(index, 1); 
        },
        onAddObjective: () => {
            self.objectives.push(ProjectSubMenuModel.create({
                no: self.objectives.length + 1,
                groupCode: "OBJECTIVE"
            }));
        },
        onRemoveObjective: (index: number) => {
            self.objectives.splice(index, 1);
        },
        onAddLocation: () => {
            self.locations.push(LocationModel.create({
                no: self.locations.length + 1,
            }));
        },
        onRemoveLocation: (index: number) => {
            self.locations.splice(index, 1);
        },
        onAddBenefit: () => {
            self.benefits.push(ProjectSubMenuModel.create({
                no: self.benefits.length + 1,
                groupCode: "BENEFIT"
            }));
        },
        onRemoveBenefit: (index: number) => {
            self.benefits.splice(index, 1);
        },
        onAddScope: () => {
            self.scopes.push(ProjectSubMenuModel.create({
                no: self.scopes.length + 1,
                groupCode: "SCOPE"
            }));
        },
        onRemoveScope: (index: number) => {
            self.scopes.splice(index, 1);
        },
        onAddProductivity: () => {
            self.productivities.push(ProjectSubMenuModel.create({
                no: self.productivities.length + 1,
                groupCode: "PRODUCTIVITY"
            }));
        },
        onRemoveProductivity: (index: number) => {
            self.productivities.splice(index, 1);
        },
        onAddResolution: () => {
            self.resolutions.push(ResolutionModel.create({
                no: self.productivities.length + 1,
                file: null // ResolutionFileModel.create({})
            }));
        },
        onRemoveResolution: (index: number) => {
            self.resolutions.splice(index, 1);
        },
        onAddNewMaterial: (type: "local" | "foreign") => {
            if (type === "local") {
                self.materials.unshift({
                    sourceType: "L",
                    currencyCode: "THB",
                });
            } else if (type === "foreign") {
                self.materials.push({
                    sourceType: "F",
                    currencyCode: "USD",
                });
            }
        },
        onAddBuggetAllocationPlan: () => {
            const BuggetAllocationYear = BuggetAllocationYearPlanModel.create({});
            BuggetAllocationYear.onAddbuggetAllocations();
            self.buggetAllocationPlans.push(BuggetAllocationYear);
        },
        onRemoveBuggetAllocationPlan: (index: number) => {
            // console.log("onRemoveBuggetAllocationPlan===>", index);
            self.buggetAllocationPlans.splice(index, 1);
        },
        onRemoveForeignMaterial: (index: number) => {
            self.materials.splice(index, 1);
        },
        onAddNewActivity: (activity: IActivityModel) => {
            self.activities.push(activity);
        },
        onRemoveActivity: (index: number) => {
            self.activities.splice(index, 1);
        },
        resetAll: () => {
            applySnapshot(self, {});
        },
    }));
export type IProjectModel = typeof ProjectModel.Type;

export const ProjectModelGetList = types
    .model("ProjectModelGetList", {
        projectID: customtypes.optional(types.number, 0),
        organizationID: customtypes.optional(types.number, 0),
        organization: customtypes.optional(SelectListModel, {}),
        projectCode: customtypes.optional(types.string, ""),
        projectType: types.optional(SelectListModel, {}),
        limitAmount: customtypes.optional(types.union(types.number, types.string), 0),
        startYear: customtypes.optional(types.number, 0),
        projectTHName: customtypes.optional(types.string, ""),
        projectENName: customtypes.optional(types.string, ""),
        projectBranch: customtypes.optional(types.string, ""),
        capitalSource: customtypes.optional(types.string, ""),
        startDate: customtypes.optional(types.string, ""),
        endDate: customtypes.optional(types.string, ""),
        processTime: customtypes.optional(types.string, ""),
        projectBackground: customtypes.optional(types.string, ""),
        projectConsistency: customtypes.optional(types.string, ""),
        projectTarget: customtypes.optional(types.string, ""),
        projectObjective: customtypes.optional(types.string, "-"),
        projectScope: customtypes.optional(types.string, "-"),
        materials: customtypes.optional(types.array(MaterialsModel),
            [
                { sourceType: "L", currencyCode: "THB" },
                { sourceType: "F", currencyCode: "USD" },
            ],
        ),
        firr: customtypes.optional(types.number, 0),
        eirr: customtypes.optional(types.number, 0),
        isNewProject: customtypes.optional(types.boolean, false),
        projectStatuses: types.maybeNull(types.array(StatusCheckingModel)),
        // 
        mapDrawing: customtypes.optional(types.string, ""),
        directorName: types.maybeNull(types.string),
        directorPosition: types.maybeNull(types.string),
        directorMail: types.maybeNull(types.string),
        directorTel: types.maybeNull(types.string),
        province: types.maybeNull(ResultLOVModel),
        sector: types.maybeNull(ResultLOVModel),
        subSector: types.maybeNull(ResultLOVModel),
        // status: types.maybeNull(types.array(ResultLOVModel)),
        status: types.maybeNull(ResultLOVOrNullModel),
        creditChannel: types.maybeNull(ResultLOVModel),
        isOnGoing: customtypes.optional(types.boolean, false),
        isGovBurden: customtypes.optional(types.boolean, false),
        hasEld: customtypes.optional(types.boolean, false),
        objectives: customtypes.optional(types.array(ProjectSubMenuModel), []),
        benefits: customtypes.optional(types.array(ProjectSubMenuModel), []),
        scopes: customtypes.optional(types.array(ProjectSubMenuModel), []),
        locations: customtypes.optional(types.array(LocationModel), []),
        productivities: customtypes.optional(types.array(ProjectSubMenuModel), []),
        iipmMaps: customtypes.optional(types.array(ProjectWktModel), []),
        resolutions: customtypes.optional(types.array(ResolutionModel), []),
        // 
        pdmoAgreement: customtypes.optional(types.number, 1),
        resolutionAgreement: customtypes.optional(types.number, 1),
        resolutionExpSum: customtypes.optional(ExpenseSummaryModel, {}),
        contractExpSum: customtypes.optional(ExpenseSummaryModel, {}),
        activities: types.maybeNull(types.array(ActivityModel)),
        lastUpdate: customtypes.optional(ActionModel, {}),
        currencyData: types.maybeNull(CurrencyModel),
        buggetAllocationPlans: customtypes.optional(types.array(BuggetAllocationYearPlanModel), []),
        error: customtypes.optional(ErrorModel, {}),
        loading: types.optional(types.boolean, false),
        alert: types.optional(MessageModel, {}),
        // iipmSyncErrors: types.maybeNull(types.string),
        iipmSyncErrors: customtypes.optional(types.array(types.string), []),
        isIIPMSyncError: types.maybeNull(types.boolean),
        sdgAmount: customtypes.optional(types.union(types.number, types.string), 0),
    })
    .views((self: any) => ({
        get localMaterial(): IMaterialsModel | undefined {
            return self.materials.find((matt: IMaterialsModel, index: number) =>
                matt.sourceType === "L",
            );
        },
        get importMaterials(): IMaterialsModel[] {
            return self.materials.filter((matt: IMaterialsModel, index: number) =>
                matt.sourceType === "F",
            );
        },
        get projectCodeView() {
            return self.projectCode || "-";
        },
        get projectTHNameView() {
            return self.projectTHName || "-";
        },
        get projectENNameView() {
            return self.projectENName || "-";
        },
        get projectBranchView() {
            return self.projectBranch || "-";
        },
        get capitalSourceView() {
            return self.capitalSource || "-";
        },
        get processTimeView() {
            return self.processTime || "-";
        },
        get projectBackgroundView() {
            return self.projectBackground || "-";
        },
        get projectConsistencyView() {
            return self.projectConsistency || "-";
        },
        get projectTargetView() {
            return self.projectTarget || "-";
        },
        get projectObjectiveView() {
            return self.projectObjective || "-";
        },
        get projectScopeView() {
            return self.projectScope || "-";
        },
        get activitiesProceedBudgetTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.budget, 0)
                :
                0;
        },
        get activitiesProceedRevernueTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.revernue, 0)
                :
                0;
        },
        get activitiesProceedDisburseLoanTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.disburseLoan, 0)
                :
                0;
        },
        get activitiesProceedOtherTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.other, 0)
                :
                0;
        },
        get activitiesProceedTotal() {
            return self.activities ?
                self.activities.reduce((sum: number, activity: IActivityModel) =>
                    sum + activity.totalProceedByActivity.total, 0)
                :
                0;
        },
        get limitAmountAsMillionBaht() {
            return self.limitAmount / 1000000;
        },
        get sdgAmountAsMillionBaht() {
            return self.sdgAmount / 1000000;
        },
        
        get dataMapDrawing() {
            return self.mapDrawing?JSON.parse(self.mapDrawing):null;
        },
    }))
    .actions((self: any) => ({

    }));
export type IProjectModelGetList = typeof ProjectModelGetList.Type;
